import { getJourney } from './io';
import { IJourneyState, IToolsState, IOutput, IOutputValue, OutputsHelper, PropertyHelper, IProperty, IOutputUsed, EPropertyTypes, EComponentTypes } from '../helpers';
import store from '../store/store';
import types from '../store/types';
import { Promise } from 'es6-promise';

let loadJourneyFromJSON = (journeyState: IJourneyState, journeyId: string): void => {

	//set tools state
	let journeyTitle: string = PropertyHelper.getPropertyValue(journeyState.Properties, 'Title');
	let isSharedJourney: boolean = PropertyHelper.getPropertyValue(journeyState.Properties, 'Shared Journey');
	let isTriageJourney: boolean = PropertyHelper.getPropertyValue(journeyState.Properties, 'Triage Journey');
	let isPageJourney: boolean = PropertyHelper.getPropertyValue(journeyState.Properties, 'Page Journey');
	let hideSteps: boolean = PropertyHelper.getPropertyValue(journeyState.Properties, 'Hide Steps');
	let replaceGuids: boolean = PropertyHelper.getPropertyValue(journeyState.Properties, 'Replace Guids');
	let isSaveAndResume: boolean = PropertyHelper.getPropertyValue(journeyState.Properties, 'Save And Resume');
	let portalAuthenticationLevel: number = PropertyHelper.getPropertyValue(journeyState.Properties, 'Portal Authentication Level');
	let portaltimeforcompletion: string = PropertyHelper.getPropertyValue(journeyState.Properties, 'Portal Time For Completion');

	let toolsState: IToolsState = {
		journeyId: journeyId,
		journeyTitle: journeyTitle,
		isSharedJourney: !!isSharedJourney,
		isTriageJourney: !!isTriageJourney,
		isPageJourney: !!isPageJourney,
		hideSteps: !!hideSteps,
		replaceGuids: !!replaceGuids,
		isSaveAndResume: !!isSaveAndResume,
		portalAuthenticationLevel: portalAuthenticationLevel ? portalAuthenticationLevel : 586430001,
		portaltimeforcompletion: portaltimeforcompletion ? portaltimeforcompletion : "{Key:'586430001', Value:'5-10 Minutes'}",
		saving: false,
		experimentalFeaturesEnabled: false,
		Properties: []

	};
	let outputs: IOutputValue[] = OutputsHelper.GetOutputsFromComponents(journeyState.Components);
	let globalOutputs: IOutput[] = journeyState.Outputs || [];
	let defaultNavigationMode: IProperty = PropertyHelper.getProperty(journeyState.Properties, 'Default Navigation Mode');
	let properties: IProperty[] = [defaultNavigationMode].filter(p => !!p);
	toolsState.Properties = properties;

	store.dispatch({ type: types.SET_TOOLS_STATE, toolsState: toolsState });

	// build lookup for used output
	let jsonJourney = JSON.stringify(journeyState);

	const extractKeyValuePairs = (input) => {
		const regex = /"([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})":|(##[^#]+##)/g;
		const dictionary = {};
		let match;
		var currentKey = null;
		while ((match = regex.exec(input)) !== null) {
			if (match[1] !== undefined) {
				currentKey = match[1];
				dictionary[currentKey] = [];
			} else if (match[2] !== undefined && currentKey !== null) {
				dictionary[currentKey].push(match[2].slice(2, -2));
			}

		}
		return dictionary;
	};

	const componentOutput = extractKeyValuePairs(jsonJourney);

	// keep track of only the components where output values are used.
	let outputsInUse = {};
	Object.keys(componentOutput).forEach(x => {
		componentOutput[x].length ?
			outputsInUse[x] = componentOutput[x]
			// outputsInUse[x] = componentOutput[x].filter((val, index) => index % 2 === 0)
			:
			null
	})

	store.dispatch({
		type: types.SET_JOURNEY_PROPERTIES,
		properties: properties
	})

	// update the output names here
	// set component name as suffix and variable name as prefix
	outputs.forEach(output => {

		const componentId = output.componentId;
		const outputName = output.Name;

		if (outputName.split('-').length > 1) {
			switch (journeyState.Components[componentId].ComponentType.ComponentTypeId) {
				case EComponentTypes.action:
					var componentName = journeyState.Components[componentId].Action.Properties.filter(x => x.Name === "Action Name")[0].Value;
					if (outputName.split('-')[0].replace(/^\s+|\s+$/g, '') === componentName) {
						output.Name = outputName.replace(componentName + ' -', '').replace(/^\s+|\s+$/g, '') + ' - ' + componentName;
						journeyState.Components[componentId].Action.OutputValues.filter(x => x.Id === output.Id)[0].Name = output.Name;
					}
					break;
				case EComponentTypes.block:
					var controlLabel = '';
					var controlFromBlock;
					var controlFromLayoutPanel;
					journeyState.Components[componentId].ControlBlock.LayoutPanels.forEach((layoutPanel, lIndex) => {
						layoutPanel.Controls.forEach((control, cIndex) => {
							if (control.OutputValues && control.OutputValues.filter(x => x.Id === output.Id).length > 0) {
								controlFromBlock = journeyState.Components[componentId].ControlBlock.Controls.filter(x => x.ControlId === control.ControlId)[0];
								controlFromLayoutPanel = journeyState.Components[componentId].ControlBlock.LayoutPanels[lIndex].Controls[cIndex];
								controlLabel = control.Properties.filter(x => x.Name === 'Label')[0].Value;
								return;
							}
						})
					})
					if (outputName.split('-')[0].replace(/^\s+|\s+$/g, '') === controlLabel) {
						output.Name = outputName.replace(controlLabel + ' -', '').replace(/^\s+|\s+$/g, '') + ' - ' + controlLabel;
						controlFromLayoutPanel.OutputValues.filter(x => x.Id === output.Id)[0].Name = output.Name = output.Name;
						controlFromBlock.OutputValues.filter(x => x.Id === output.Id)[0].Name = output.Name = output.Name;
					}
					break;

				// implement logic when working with loop component and shared journey component
				case EComponentTypes.sharedJourney:
					break;
				case EComponentTypes.loop:
					break;
			}

		}
	})

	// Set components and global outputs
	if (journeyState.Components)
		store.dispatch({ type: types.SET_PROCESS_STATE, components: journeyState.Components, StartId: journeyState.StartId });

	store.dispatch({
		type: types.SET_ACTIVE_COMPONENTS,
		components: journeyState.Components
	});

	store.dispatch({
		type: types.SET_OUTPUT_STATE,
		outputs: outputs,
		globalOutputs: globalOutputs,
		outputsInUse: outputsInUse
	});
	store.dispatch({
		type: types.SET_GLOBAL_OUTPUTS_STATE,
		outputs: globalOutputs
	});



};

export let loadJourneyFromId = (journeyId: string): Promise<any> => {

	let promise = new Promise<any>((resolve, reject) => {

		journeyId = journeyId || '';

		getJourney(journeyId).then(
			(stateToHydrate) => {

				if (stateToHydrate) {
					loadJourneyFromJSON(stateToHydrate, journeyId);
				}
				else {
					reject();
				}

				resolve(stateToHydrate);

			}, (error) => {
				reject(error);
			}
		);

	});

	return promise;

};


// WEBPACK FOOTER //
// ./source/ts/helpers/rehydration.ts